module.exports = __webpack_public_path__ + "static/media/ea8cbe9f-0354-4002-b513-b0bd981415f9.e0a1e474.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/ea8cbe9f-0354-4002-b513-b0bd981415f9.jpg
// module id = 860
// module chunks = 0